import { render, staticRenderFns } from "./BandwidthSms.vue?vue&type=template&id=3462b2de&"
import script from "./BandwidthSms.vue?vue&type=script&lang=js&"
export * from "./BandwidthSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/danford/drochat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3462b2de')) {
      api.createRecord('3462b2de', component.options)
    } else {
      api.reload('3462b2de', component.options)
    }
    module.hot.accept("./BandwidthSms.vue?vue&type=template&id=3462b2de&", function () {
      api.rerender('3462b2de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/channels/BandwidthSms.vue"
export default component.exports